



















import { Component, Prop, Vue } from "vue-property-decorator";
import DashboardDataCard from "./DashboardDataCard.vue";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";

@Component({
  components: {
    DashboardDataCard,
  },
})
export default class DashboardCommandesEnCoursCard extends Vue {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;
  @Prop({ default: "" }) public styleClass!: string;
  @Prop({ default: () => ({}) }) public styleObject!: object;

  get ticketsEtCouverts(): string {
    return this.dashboardData.TicketsEtCouverts["CA EN COURS"] || "0/0/0";
  }

  get caTotal(): number {
    return this.dashboardData.CAParService.TOTAL + this.dashboardData.CAEnCours;
  }

  get caCouvertsTotal(): number {
    // CA total des couverts (encaissé + en cours)
    return this.caTotal;
  }

  get caTablesTotal(): number {
    // CA total des tables (encaissé + en cours)
    return this.caTotal;
  }

  get caTicketsTotal(): number {
    // CA total des tickets (encaissé + en cours)
    return this.caTotal;
  }
}
